<div class="mb-4">
    <p>We have sent a 4-digit code via SMS to <span class="fw-bold">{{userInputData?.phone}}.</span> Please enter it
        here.</p>
</div>
<form [formGroup]="otpForm">
    <div class="d-flex justify-content-start mb-4">
        <input name="text1" formControlName="text1" class="form-control text-center otp-input" type="tel" id="first"
            maxlength="1" (keydown)="handleBackspace($event, '')" (input)="moveToNext($event, 'second')"
            (keyup.enter)="onEnterPressed()" pattern="[0-9]*" />
        <input name="text2" formControlName="text2" class="form-control text-center otp-input" type="tel" id="second"
            maxlength="1" (keydown)="handleBackspace($event, 'first')" (input)="moveToNext($event, 'third')"
            (keyup.enter)="onEnterPressed()" pattern="[0-9]*" />
        <input name="text3" formControlName="text3" class="form-control text-center otp-input" type="tel" id="third"
            maxlength="1" (keydown)="handleBackspace($event, 'second')" (input)="moveToNext($event, 'fourth')"
            (keyup.enter)="onEnterPressed()" pattern="[0-9]*" />
        <input name="text4" formControlName="text4" class="form-control text-center otp-input" type="tel" id="fourth"
            maxlength="1" (keydown)="handleBackspace($event, 'third')" (input)="emitOtp()"
            (keyup.enter)="onEnterPressed()" pattern="[0-9]*" />
    </div>
</form>
<div class="mb-4">
    <span>Didn’t receive a code?</span>
    <span (click)="resendOTP()" class="register-text ms-1">Resend OTP</span>
</div>